import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-782c053a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "header"
}
const _hoisted_2 = { class: "wrap_header" }
const _hoisted_3 = { class: "menubar" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-map-marker",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("CheckIn hằng ngày")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "p-menuitem-icon pi pi-fw pi-map-marker",
  "data-pc-section": "icon"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("CheckIn trực")
const _hoisted_8 = {
  key: 1,
  id: "fotter"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wrap_header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "coppyi" }, "© Copyright 2025 - Bệnh viện phổi Đà Nẵng")
], -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($props.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createVNode(_component_RouterLink, { to: "/location" }, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _createVNode(_component_RouterLink, { to: "/locationOverTime" }, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($props.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
      : _createCommentVNode("", true)
  ], 64))
}